<template>
  <div class="usage-top">
    <!-- eslint-disable vue/no-v-model-argument -->
    <a-tabs v-model:activeKey="activeKey">
      <a-tab-pane :tab="item.title" :key="index" v-for="(item, index) in tabsList">
        <div class="list-card">
          <div class="item" v-for="(card, i) in item.list" :key="i">
            <div class="title">{{ card.name }}</div>
            <span class="count">{{ card.count }}</span>
            <span class="unit">{{ card.unit }}</span>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { Tabs } from "ant-design-vue";
import { defineComponent, reactive, ref } from "vue";
const TabPane = Tabs.TabPane;
export default defineComponent({
  name: "usage-tabs",
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane
  },
  setup() {
    const tabsList = reactive([
      {
        title: "会议室",
        list: [
          {
            name: "会议室数",
            count: "10",
            unit: "个"
          },
          {
            name: "设备数",
            count: "6",
            unit: "个"
          },
          {
            name: "平均温度",
            count: "23",
            unit: "℃"
          }
        ]
      },
      {
        title: "办公室",
        list: [
          {
            name: "办公室个数",
            count: "10",
            unit: "个"
          },
          {
            name: "设备数",
            count: "6",
            unit: "个"
          },
          {
            name: "平均温度",
            count: "23",
            unit: "℃"
          }
        ]
      },
      {
        title: "共享工位",
        list: [
          {
            name: "共享工位个数",
            count: "10",
            unit: "个"
          },
          {
            name: "设备数",
            count: "6",
            unit: "个"
          },
          {
            name: "平均温度",
            count: "23",
            unit: "℃"
          }
        ]
      }
    ]);
    const activeKey = ref(0);
    return { activeKey, tabsList };
  }
});
</script>

<style lang="less" scoped>
.usage-top {
  height: 216px;
  margin-bottom: 16px;
  padding: 24px;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  :deep(.ant-tabs-nav) {
    margin-bottom: 24px;
  }
  :deep(.ant-tabs-tab) {
    margin-left: 4px;
    padding: 12px 16px;
    &:hover {
      color: #5e66f2;
    }
  }
  :deep(.ant-tabs-ink-bar-animated) {
    display: none;
  }
  :deep(.ant-tabs-tab-active) {
    border-bottom: 2px solid #5e66f2;
    .ant-tabs-tab-btn {
      color: #5e66f2;
      font-weight: 600;
    }
  }
  .list-card {
    display: flex;

    .item {
      flex: 1;
      height: 96px;
      padding: 16px;
      background-color: #f7f8fa;
      &:nth-child(2) {
        margin: 0 16px;
      }
      .title {
        height: 22px;
        margin-bottom: 8px;
        color: #4e5969;
        font-size: 14px;
        line-height: 22px;
      }
      .count {
        margin-right: 4px;
        color: #1d2129;
        font-size: 24px;
        font-family: DINBold;
      }
      .unit {
        display: inline-block;
        color: #86909c;
        font-size: 12px;
        transform: translateY(-4px);
      }
    }
  }
}
</style>
